export default __webpack_public_path__ + "static/media/optionstwo.efaef0e0.png";